import React from 'react';
import { ArticleList as ArticleListUI } from '@shapegames/web-library-quick-draw-ui/dist/ArticleList';
import { Article } from 'src/services/articles';
import formatArticleDate from 'src/utils/format-article-date';
import Link from '../../../components/Link';
import Image from 'next/legacy/image';
import { imageUrlMaker, mapCropsToImageSizes } from 'src/utils/image-helpers';
import styled from 'styled-components';

interface ArticleListProps {
  title?: string;
  articles: Article[];
}

function ArticleListItem({ article }: { article: Article }) {
  const cropUrl =
    article.image?.url &&
    imageUrlMaker({
      imageUrl: article.image.url,
      cropType: 'thumbnailCrop',
      crop: article.landscapeCrop,
    });

  const { width, height } = mapCropsToImageSizes['thumbnailCrop'];

  return (
    <ArticleListUI.Item
      title={article.title}
      imageUrl={article.image?.url || undefined}
      author={article.author?.name}
      createdAt={formatArticleDate(article.createdAt)}
      renderItem={content => (
        <Link href={`/${article.mainArticleGroup.slug}/${article.slug}`}>
          {content}
        </Link>
      )}
      imageNode={
        cropUrl && (
          <ImageThumbnailWrapper>
            <Image
              width={width}
              height={height}
              src={cropUrl}
              layout="fixed"
              alt={article?.image?.alt ?? 'image-description'}
            />
          </ImageThumbnailWrapper>
        )
      }
    />
  );
}

function ArticleList({ title, articles }: ArticleListProps) {
  return (
    <ArticleListUI title={title}>
      {articles.map(art => (
        <ArticleListItem key={`article-${art.slug}`} article={art} />
      ))}
    </ArticleListUI>
  );
}

const ImageThumbnailWrapper = styled.div`
  width: 93px;
  height: 100%;
  margin-right: ${p => p.theme.sizes.spacing3};
`;

export default ArticleList;
